import axios from 'axios';
import queryString from 'query-string';
import _, { snakeCase } from 'lodash';
import { API_URL } from '../config';

export const prepareTableParams = (params, defaultSortable) => {
  const order = params.order || 'asc';
  const sortBy = params.sortBy ? params.sortBy : defaultSortable;

  const {
    page = 1,
    limit: perPage = 10,
  } = params;

  return {
    page,
    perPage,
    'sort[]': `${snakeCase(sortBy)},${order}`,
  };
};

export const prepareParams = (params, filters, defaultSortable) => {
  const filterParams = _.reduce(
    filters,
    (result, val, key) => {
      result[snakeCase(key)] = `%${val}%`; // eslint-disable-line no-param-reassign
      return result;
    },
    {},
  );

  const tblParams = prepareTableParams(params, defaultSortable);

  const paramsToStringify = {
    ...filterParams,
    ...tblParams,
  };

  return paramsToStringify;
};

export const getVehiclesData = (params, filters) => {
  const paramsToStringify = prepareParams(params, filters, 'name');
  const URL = `${API_URL}/vehicle-models?${queryString.stringify(paramsToStringify)}`;
  return axios.get(URL).then((res) => res.data);
};

export const storeVehicleModel = (data) => {
  const URL = `${API_URL}/vehicle-models`;
  return axios.post(URL, data).then((res) => res.data);
};

export const updateVehicleModel = (data) => {
  const { id, ...payload } = data;
  const URL = `${API_URL}/vehicle-models/${id}`;
  return axios.put(URL, payload).then((res) => res.data);
};

export const removeVehicleModel = (id) => {
  const URL = `${API_URL}/vehicle-models/${id}`;
  return axios.delete(URL).then((res) => res.data);
};

export const getManufacturersData = (params, filters) => {
  const paramsToStringify = prepareParams(params, filters, 'manufacturerName');
  const URL = `${API_URL}/vehicle-manufacturers?${queryString.stringify(paramsToStringify)}`;
  return axios.get(URL).then((res) => res.data);
};

export const storeManufacturerData = (data) => {
  const URL = `${API_URL}/vehicle-manufacturers`;
  return axios.post(URL, data).then((res) => res.data);
};

export const updateManufacturerData = (data) => {
  const { id, ...payload } = data;
  const URL = `${API_URL}/vehicle-manufacturers/${id}`;
  return axios.put(URL, payload).then((res) => res.data);
};

export const removeManufacturerData = (id) => {
  const URL = `${API_URL}/vehicle-manufacturers/${id}`;
  return axios.delete(URL).then((res) => res.data);
};
